__turbopack_context__.v({
  "reset": "UnorderedList-module-scss-module__d8xWNa__reset",
  "unorderedList": "UnorderedList-module-scss-module__d8xWNa__unorderedList",
});
